import React from "react";
import logoLight from "../../assets/images/logo-horizontal-light.svg";
import logoDark from "../../assets/images/logo-horizontal-dark.svg";
import { ThemeType, ThemeTypeEnum } from "../../assets/utils/validation/types";
import { useNavigate } from "react-router-dom";

export default function Header({ theme }: { theme: ThemeType }) {
  const navigate = useNavigate();
  return (
    <header>
      <img
        onClick={() => navigate("/")}
        src={theme === ThemeTypeEnum.LIGHT ? logoLight : logoDark}
        alt="logo-image"
      />
    </header>
  );
}
